import Fetch from "./index";

export const getMetaAdsIntegration = async ({ assistantID }) => {
    if (!assistantID)
        return Promise.reject("failed to read id");

    return Fetch("/meta-ads-integration/?assistantID=" + assistantID)
}

export const createMetaAdsIntegration = async (body) => {
    const data = new FormData();
    for (const key in body) {
        data.set(key, body[key]);
    }

    return Fetch(
        '/meta-ads-integration/',
        {
            method: 'POST',
            body: data,
        },
    )
}

export const deleteMetaAdsIntegration = async (id) => {
    return Fetch(
        '/meta-ads-integration/' + id,
        {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const updateMetaAdsIntegration = async (id, body) => {
    delete body['createdAt']
    delete body['updatedAt']
    delete body['deletedAt']
    delete body['id']

    const data = new FormData();
    for (const key in body) {
        data.set(key, body[key]);
    }

    return Fetch(
        '/meta-ads-integration/' + id,
        {
            method: 'PUT',
            body: data,
        },
    )
}

export const getMetaAdsAdAccounts = async (integrationId) => {
    if (!integrationId)
        return Promise.reject("integration id is required");

    return Fetch(`/meta-ads-integration/${integrationId}/ad-accounts`)
}

export const getMetaAdsPixels = async (integrationId, accountId) => {
    if (!integrationId || !accountId)
        return Promise.reject("integration id and account id are required");

    return Fetch(`/meta-ads-integration/${integrationId}/pixels?account_id=${accountId}`)
}

